var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderToolbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 1920 1920",
    style: {
      enableBackground: "new 0 0 1920 1920"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#93D5F6",
    d: "M1919.5,960c0,529.9-429.6,959.5-959.5,959.5S0.5,1489.9,0.5,960S430.1,0.5,960,0.5S1919.5,430.1,1919.5,960"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.5,959.9c0-6.2-0.1-12.3-0.2-18.4c0,1.3,0,2.7,0,4C1919.5,950.4,1919.5,955.1,1919.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,978.4c0.1-6.1,0.2-12.3,0.2-18.4c0,4.8,0,9.6-0.2,14.4C1919.3,975.7,1919.3,977,1919.3,978.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,974.3c0,1.3,0,2.7,0,4.1C1919.3,977,1919.3,975.7,1919.3,974.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,945.6L1919.3,945.6c0-1.3,0-2.7,0-4.1C1919.3,942.9,1919.3,944.2,1919.3,945.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.5,959.9c0,4.8-0.1,9.6-0.2,14.4C1919.5,969.5,1919.5,964.7,1919.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.5,959.9c0-4.8,0-9.6-0.2-14.4C1919.4,950.4,1919.5,955.1,1919.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,945.6c0.1,4.8,0.2,9.6,0.2,14.4C1919.5,955.1,1919.4,950.4,1919.3,945.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,974.3c0.1-4.8,0.2-9.6,0.2-14.4C1919.5,964.8,1919.4,969.5,1919.3,974.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1416.8,1642.2c-127.9,102-285,168.9-456.8,185.9c28.6,2.8,57.7,4.3,87,4.3c475.7,0,862.5-380.7,872.3-854 C1911.4,1291.1,1702.4,1553.8,1416.8,1642.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M1919.3,941.5c-9.8-473.4-396.6-854-872.2-854c-29.4,0-58.4,1.5-87.1,4.3c171.8,17,329,83.9,456.8,185.9 C1702.4,366.1,1911.4,628.8,1919.3,941.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M1578,1473.9c-46,63-100.3,119.6-161.2,168.3c285.6-88.4,494.6-351.1,502.5-663.8c0-1.3,0-2.7,0-4 C1913.6,1199.4,1774.5,1391.3,1578,1473.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M1416.8,277.7C1477.7,326.3,1532,383,1578,446c196.4,82.6,335.6,274.5,341.3,499.6c0-1.3,0-2.7,0-4.1 C1911.4,628.8,1702.4,366.1,1416.8,277.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M1660.5,1335.9c-23.3,48.7-50.9,94.8-82.5,138c196.4-82.6,335.6-274.5,341.3-499.6c0.1-4.8,0.2-9.6,0.2-14.4 C1919.5,1131.7,1811.9,1278.2,1660.5,1335.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M1859.8,960c0,389.5-402.8,705.3-899.7,705.3S60.2,1349.5,60.2,960S463.1,254.7,960,254.7 S1859.8,570.5,1859.8,960"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M1578,446c31.5,43.2,59.2,89.3,82.5,138c151.4,57.7,259.1,204.3,259.1,376c0-4.8-0.1-9.6-0.2-14.4 C1913.6,720.5,1774.5,528.6,1578,446"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M1660.5,584c20.4,42.6,37.4,87.2,50.7,133.3c117.9,17.9,208.3,119.7,208.3,242.7 C1919.5,788.2,1811.9,641.7,1660.5,584"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M1711.2,1202.6c-13.3,46.1-30.4,90.7-50.7,133.3c151.4-57.7,259-204.3,259-376 C1919.5,1082.9,1829.2,1184.7,1711.2,1202.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M1711.2,717.3c22.3,77,34.2,158.5,34.2,242.7s-12,165.6-34.2,242.7c117.9-17.9,208.3-119.7,208.3-242.7 C1919.5,837,1829.2,735.2,1711.2,717.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M503.2,277.7C631,175.7,788.2,108.8,960,91.8c-28.6-2.8-57.7-4.3-87-4.3c-475.7,0-862.5,380.7-872.3,854 C8.6,628.8,217.6,366.1,503.2,277.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#36A9E1",
    d: "M0.7,978.4c9.8,473.4,396.6,854,872.3,854c29.4,0,58.4-1.5,87-4.3c-171.8-17-329-83.9-456.8-185.9 C217.6,1553.8,8.6,1291.1,0.7,978.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M1205.5,1674c-86.3,0-168.9-15.3-245.5-43.3c-76.6,28-159.3,43.3-245.5,43.3c-73.6,0-144.5-11.1-211.3-31.8 c127.9,102,285,168.9,456.8,185.9c171.8-17,328.9-83.9,456.8-185.9C1350,1662.8,1279.1,1674,1205.5,1674"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M714.5,245.9c86.3,0,168.9,15.3,245.5,43.3c76.6-28,159.3-43.3,245.5-43.3c73.6,0,144.5,11.1,211.3,31.8 c-127.9-102-285-168.9-456.8-185.9c-171.8,17-328.9,83.9-456.8,185.9C570,257.1,640.9,245.9,714.5,245.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M1416.8,277.7c-66.8-20.7-137.7-31.8-211.3-31.8c-86.3,0-168.9,15.3-245.5,43.3 c86.4,31.6,165,79.5,232.1,139.9c53.6-17.2,110.8-26.5,170.2-26.5c76.5,0,149.4,15.4,215.8,43.3 C1532,383,1477.7,326.3,1416.8,277.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M1192.1,1490.7c-67.1,60.4-145.7,108.3-232.1,139.9c76.5,28,159.2,43.3,245.5,43.3 c73.6,0,144.5-11.1,211.3-31.8c60.9-48.7,115.2-105.3,161.2-168.3c-66.3,27.9-139.2,43.3-215.8,43.3 C1302.9,1517.2,1245.7,1507.9,1192.1,1490.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M1192.1,429.2c55.4,49.9,103,108.3,140.6,173.3c55.3-28.6,118-44.8,184.6-44.8c50.4,0,98.7,9.3,143.2,26.3 c-23.3-48.7-51-94.8-82.5-137.9c-66.3-27.9-139.2-43.3-215.8-43.3C1302.9,402.7,1245.7,412,1192.1,429.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M1332.7,1317.4c-37.6,64.9-85.2,123.4-140.6,173.3c53.6,17.2,110.8,26.5,170.2,26.5 c76.5,0,149.4-15.4,215.8-43.3c31.5-43.2,59.2-89.3,82.5-137.9c-44.5,17-92.8,26.3-143.2,26.3 C1450.7,1362.2,1388,1346,1332.7,1317.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M1669.7,960c0,307.2-317.7,556.3-709.7,556.3S250.4,1267.2,250.4,960S568.1,403.7,960,403.7 S1669.7,652.8,1669.7,960"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M1428.5,959.9c0,130.3-34.9,252.3-95.8,357.5c55.3,28.6,118,44.7,184.6,44.7c50.5,0,98.7-9.3,143.2-26.3 c20.4-42.6,37.4-87.2,50.7-133.3c-12.1,1.8-24.5,2.8-37.2,2.8C1538.4,1205.4,1428.5,1095.5,1428.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M1332.7,602.5c60.9,105.1,95.8,227.2,95.8,357.5c0-135.6,109.9-245.5,245.5-245.5c12.7,0,25.1,1,37.2,2.8 c-13.3-46.1-30.3-90.7-50.7-133.3c-44.5-17-92.8-26.3-143.2-26.3C1450.7,557.7,1388,573.9,1332.7,602.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    fill: "#1E2A6E",
    d: "M1428.5,959.9c0,135.6,109.9,245.5,245.5,245.5c12.7,0,25.1-0.9,37.2-2.8c22.3-77.1,34.3-158.5,34.3-242.7 s-12-165.6-34.3-242.7c-12.1-1.8-24.5-2.8-37.2-2.8C1538.4,714.5,1428.5,824.4,1428.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M503.2,1642.2c-60.9-48.6-115.2-105.3-161.2-168.3C145.5,1391.3,6.4,1199.4,0.7,974.3c0,1.3,0,2.7,0,4.1 C8.6,1291.1,217.6,1553.8,503.2,1642.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#008ECF",
    d: "M503.2,277.7C217.6,366.1,8.6,628.8,0.7,941.5c0,1.3,0,2.7,0,4.1C6.4,720.5,145.5,528.6,342,446 C388,383,442.3,326.3,503.2,277.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M503.2,1642.2c66.8,20.7,137.7,31.8,211.3,31.8c86.3,0,168.9-15.3,245.5-43.3c-86.4-31.6-165-79.5-232.1-139.9 c-53.6,17.2-110.8,26.5-170.2,26.5c-76.5,0-149.4-15.4-215.8-43.3C388,1536.9,442.3,1593.6,503.2,1642.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M727.9,429.2C795,368.8,873.6,320.9,960,289.2c-76.5-28-159.3-43.3-245.5-43.3c-73.6,0-144.5,11.1-211.3,31.8 C442.3,326.4,388,383,342,446c66.4-27.9,139.2-43.3,215.8-43.3C617.1,402.7,674.3,412,727.9,429.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M960,574.3c63.3-66.1,142.8-116.5,232.1-145.1C1125,368.8,1046.4,320.9,960,289.3 c-86.4,31.6-165,79.5-232.1,139.9C817.2,457.8,896.7,508.2,960,574.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M960,1345.6c-63.3,66.1-142.8,116.5-232.1,145.1C795,1551.1,873.6,1599,960,1630.6 c86.4-31.6,165-79.5,232.1-139.9C1102.8,1462.1,1023.3,1411.7,960,1345.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M1115,959.9c0,149.7-59,285.5-155,385.6c63.3,66.1,142.8,116.5,232.1,145.1c55.4-49.9,103-108.4,140.6-173.3 C1203.4,1250.6,1115,1115.6,1115,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M960,574.3c96,100.1,155,236,155,385.6c0-155.6,88.4-290.6,217.7-357.5c-37.6-64.9-85.2-123.4-140.6-173.3 C1102.8,457.8,1023.3,508.2,960,574.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    fill: "#1E2A6E",
    d: "M1115,959.9c0,155.6,88.4,290.6,217.7,357.5c60.9-105.2,95.8-227.2,95.8-357.5s-34.9-252.3-95.8-357.5 C1203.4,669.3,1115,804.3,1115,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M259.5,584c23.3-48.7,50.9-94.8,82.5-138C145.5,528.6,6.3,720.5,0.7,945.6c-0.1,4.8-0.2,9.6-0.2,14.4 C0.5,788.2,108.1,641.7,259.5,584"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#006AB0",
    d: "M342,1473.9c-31.5-43.2-59.2-89.3-82.5-138c-151.4-57.7-259.1-204.3-259.1-376c0,4.8,0.1,9.6,0.2,14.4 C6.4,1199.4,145.5,1391.3,342,1473.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M727.9,1490.7c-55.4-49.9-103-108.3-140.6-173.3c-55.3,28.6-118,44.8-184.6,44.8c-50.4,0-98.7-9.3-143.2-26.3 c23.3,48.7,51,94.8,82.5,137.9c66.4,27.9,139.2,43.3,215.8,43.3C617.1,1517.2,674.3,1507.9,727.9,1490.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M587.3,602.5c37.6-64.9,85.2-123.4,140.6-173.3c-53.6-17.2-110.8-26.5-170.2-26.5 c-76.5,0-149.4,15.4-215.8,43.3c-31.5,43.2-59.2,89.3-82.5,137.9c44.5-17,92.8-26.3,143.2-26.3C469.3,557.7,532,573.9,587.3,602.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M805,959.9c0-149.7,59-285.5,155-385.6c-63.3-66.1-142.8-116.5-232.1-145.1c-55.4,49.9-103,108.4-140.6,173.3 C716.6,669.3,805,804.3,805,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M960,1345.6c-96-100.1-155-236-155-385.6c0,155.6-88.4,290.6-217.7,357.5c37.6,64.9,85.2,123.4,140.6,173.3 C817.2,1462.1,896.7,1411.7,960,1345.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    fill: "#1E2A6E",
    d: "M960,574.3c-96,100.1-155,236-155,385.6c0,149.7,59,285.5,155,385.6c96-100.1,155-236,155-385.6 C1115,810.3,1056,674.4,960,574.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M208.8,717.3c13.3-46.1,30.4-90.7,50.7-133.3C108.1,641.7,0.5,788.2,0.5,960C0.5,837,90.9,735.2,208.8,717.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#004490",
    d: "M259.5,1335.9c-20.4-42.6-37.4-87.2-50.7-133.3C90.8,1184.7,0.5,1082.9,0.5,960 C0.5,1131.7,108.1,1278.2,259.5,1335.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M587.3,1317.4c-60.9-105.1-95.8-227.2-95.8-357.5c0,135.6-109.9,245.5-245.5,245.5c-12.7,0-25.1-1-37.2-2.8 c13.3,46.1,30.3,90.7,50.7,133.3c44.5,17,92.8,26.3,143.2,26.3C469.3,1362.2,532,1346,587.3,1317.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M491.5,959.9c0-130.3,34.9-252.3,95.8-357.5c-55.3-28.6-118-44.7-184.6-44.7c-50.5,0-98.7,9.3-143.2,26.3 c-20.4,42.6-37.4,87.2-50.7,133.3c12.1-1.8,24.5-2.8,37.2-2.8C381.6,714.5,491.5,824.4,491.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    fill: "#1E2A6E",
    d: "M805,959.9c0-155.6-88.4-290.6-217.7-357.5c-60.9,105.2-95.8,227.2-95.8,357.5s34.9,252.3,95.8,357.5 C716.6,1250.6,805,1115.6,805,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "#1D327B",
    d: "M208.8,1202.6c-22.3-77-34.2-158.5-34.2-242.7c0-84.2,12-165.6,34.2-242.7C90.9,735.2,0.5,837,0.5,959.9 C0.5,1082.9,90.9,1184.7,208.8,1202.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    fill: "#1E2A6E",
    d: "M491.5,959.9c0-135.6-109.9-245.5-245.5-245.5c-12.7,0-25.1,0.9-37.2,2.8c-22.3,77.1-34.3,158.5-34.3,242.7 s12,165.6,34.3,242.7c12.1,1.8,24.5,2.8,37.2,2.8C381.6,1205.4,491.5,1095.5,491.5,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M562.1,385.7l22.2,11.5c1.4,0.7,2.9,0.7,4.3,0.1c8-3.2,20.2-5,25-0.1c2.8,2.9,5,8.4,2.8,15 c-0.2,0.6,0,1.3,0.6,1.7l9.4,4.8c1.4-1.4,3.8-4.1,6.4-6.9c14.7-16.1,30.9-33.4,40.4-40.4c-4.7-2.8-13.5-4.9-17.7-2l-1.5,1l-1.5-1.1 c-2-1.4-5.3-2.3-8.9-2.3c-4.8,0-8.8,1.4-10.4,2.7c3.6,3.9,7,8.6,5.7,12.9c-0.8,2.8-3.4,4.7-7.5,5.7c-1,0.2-1.8,0.2-2.4,0.2 c-1.6,0-2.9-0.5-3.8-1.4c-1.4-1.5-1.2-3.4-1.1-5.2c0.2-2.6,0.2-4.3-1.8-6c-1.9-1.7-4.4-0.6-6.9,0.6c-1.8,0.8-3.5,1.6-5.3,1.6 c-1.7,0-4.1-0.7-5.5-4.3c-0.9-2.5-0.7-5,0.7-7.1c2.3-3.4,7.3-4.9,11.2-4.9c1.8,0,3.4,0.3,4.7,0.9c0.2-0.6,0.4-1.7,0.4-3.2 c-0.1-3-1.3-6.8-3.8-8.3l-1.7-1l0.6-1.9c0.6-2.1,1.3-10-1.4-13.5c-0.9-1.2-2-1.7-3.7-1.7c-2,0-5.6,0.8-11.7,4.9l-1.8,1.2l-1.5-1.6 c0.2,0.2-0.4,0-1.5,0c-0.9,0-8.4,0.2-11.6,7.9c4.6,2.3,8.9,7.1,8.8,11.8c0,1.7-0.8,5.8-7.1,7.3c-7,1.7-8.5-3.1-9.2-5.9 c-0.6-2.2-1-3.6-2.6-4.5c-1.5-0.9-2.1-0.6-3.6,0.6c-1.1,0.9-2.5,2-4.4,2c-2.7,0-4.7-2.1-5.9-3.7c-3-3.8-2.3-6.7-1.6-8.1 c1.7-3.5,6.1-4.7,9.4-4.7c1.3,0,2.5,0.2,3.5,0.5c0.6-1.2,1-3.1,0.7-5.4c-0.4-2.3-1.8-6.3-7.5-7.9l-2.1-0.5l0.2-3.5 c0.4-5.1,1-13.3-9.2-17.1c-0.2,11.5-4.6,27.5-8.6,41.8c-2.8,10-6.1,22.3-5.4,25.4L562.1,385.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M492.7,515.9c25.9,0,46.2-30.4,76.7-7.4l0.5-4.5c-14.2-15.4-33.9-19.6-53.3-10.9c-19,8.5-34.2,0.4-34.2-14 c0-5.8,3.5-13.7,11.9-17.1c-17.7-1.4-34.1,10.4-34.1,24.3C460.1,503.3,473.4,515.9,492.7,515.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M464.2,425.8l20.8-7.4l19.1-1c0,0,4.6-9.4,4.9-10.4c-0.1,0-1.9-6.1-1.9-6.1s1.1-4.1,3.5-7.7 c-27.2,0-15.6,0-25.6,0l-21-7.4l-3.8,6.9c1.9,1.7,5,5.6,5,12.8c0,6.7-2.1,9.7-5,13C461.2,420.3,464.2,425.8,464.2,425.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M646.5,414.2c72.9-1.7,139.7-3.1,141.1-3.1c2.3-0.1,15.6-5.7,21.8-8.8c-6.2-3.1-18.7-8.8-21.8-8.8 c-2.2,0-56.6-0.1-121.2-0.1C659.7,400.1,652.4,407.9,646.5,414.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M347.7,420.4l4.1-1.1v-24.5l-4.1-1.2c-7.5-2.1-14.9,3.5-14.9,11.3v4.3C332.8,416.9,340.2,422.5,347.7,420.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M451.6,453.2l-2.6-5.4v-31c3.1-2.3,5.2-6.4,5.2-11.1s-2.1-8.8-5.2-11.1v-31l2.6-5.4v-2.1h-19.7v2.1l2.6,5.4 v84.1l-2.6,5.4v2.1h19.7V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M371.3,548.8c-0.4,5.6,2.3,11,6.9,14.1c5.7,3.8,17.8,10.9,24.4,15.3l37.1-40.1c-4-3.4-9-10.3-10.4-15.5h-56.8 C372.3,531,371.9,541.5,371.3,548.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M699.8,496.9c0,32.3,20.4,49.3,44.9,66.1c3.3-2.8,7.8-6.2,12.7-9.5c-24.5-16.7-42.5-30.1-42.5-56.6 c0-48.6,41-52.3,53.6-52.3c26.1,0,52.5,16.2,52.5,52.3c0,24.9-19.5,40.6-33.5,49.6c-13.9,8.9-30.2,18.4-40.7,29.4l-0.2-0.1 c-2.5-0.6-4.9-0.8-7.3-0.8c-35.5-2.5-44.3,27.6-30.2,37.7c0.2,12,8.5,21.8,15.2,21.6c3.2,3.1,6.9,6.1,11.3,8.8 c3.8-0.4,10-2.7,10-2.7c-2.7-8.5-14.4-29.4,6.2-51.7c10.8-11.7,31.1-23.7,50.5-37c22.3-15.4,33.6-33.6,33.6-54.8 c0-46.3-35-67.3-67.5-67.3C736.7,429.6,699.8,447.2,699.8,496.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    fill: "#FFFFFF",
    points: "409.8,430.3 423.5,430.3 423.5,383 409.8,378.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    fill: "#FFFFFF",
    points: "362.4,430.3 376.1,430.3 376.1,383 362.4,378.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    fill: "#FFFFFF",
    points: "385.8,430.3 399.5,430.3 399.5,383 385.8,378.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M378.2,480.1c-0.6,9.6-1.7,20.5-2.1,31.5h47.4c-2.7-12.2-5.7-28-8-39.5h-0.1l5.8-31.9l-51.6-0.5l6.9,25.4 C377.9,470,378.5,475.1,378.2,480.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M447.7,545.7l-33.2,37.5c20.7,13.6,39.9,27.6,45.6,31.3c11.9-7.6,23.4-19.7,30.9-29.9 c-5.2-5.1-12.3-13.8-15.5-21.8C466,557.1,457.6,551.6,447.7,545.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M394.3,851.9c-2.4,2.7-4.3,4.6-5.2,7.8c-9.3,2.8-16.7,11.1-17.2,22.1c27.3-6.3,40.8-6,65.2-2.5 c1.3,2,1.2,3.8,1.2,3.8s-25.4,0.2-40.6,7.1c-0.9,2.5-1,5.6-0.6,8.2c-6,9.4-5,18.6,2,27.3c25.7-38.6,82.3-39.9,68.4,3.5 c13.4,2.5,22.1-9.2,27.8-22.4c5.7-13.3-2.1-33.3,23.5-37.2c10.4-1.6,20.2-3.6,33.4-7.6c-0.3-4.5-5.2-14.7-9-19.2 c7.4,0,17.6,8.7,21.1,14.5c3.3-1.4,7.3-3.5,10.6-5.1c-1.2-4.6-10.4-15.8-15-20c7.7,0.7,21.1,9,25.5,14.3c2.9-1.8,5.8-3.7,8.6-5.7 c-1.4-4.5-8.8-14.7-14.8-19.2c6.5-0.1,20,7.2,24.5,11.5c3-2.6,5.8-5.3,8.4-8.2c-11.1-29.6,8.1-44.7,41-59.9 c1.6-0.8,8.9-3.8,15-6.9c-2.6-11-5.7-35.9-4.3-48.5c-17-5-43.7-8.1-56.7-8.1c-20.9,8.4-63,38.9-75.2,56.6 c26.8,18.4,13,100.2-63.8,89.8c-19.5-2.6-27.4-20.9-39.1-27.9c-2.5,0.5-5.6,1.7-8.6,3.6c-9.7-3.8-21.7-1.2-28.5,8.4 c22.7,4.1,36,15.5,44.9,26.9c-0.3,0.9-0.7,2.3-0.7,2.3S408.1,851.9,394.3,851.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M751,758.1c-1.2-3.2-2.2-6.9-2.9-10.9c-4.5-1.6-16.2-3.2-20.3-3.7c1.3-5.2,12.8-7.1,18.9-7.6 c-0.3-4-0.3-8.1-0.2-12c-4.1-1.3-14.4-3.2-17.9-3.6c1.3-5.3,12.4-6.7,18.7-7.1c0.5-4.1,1.3-7.7,2.2-10.7c2,0.2,4,0.3,5.9,0.3 c8.6,0,16.3-0.1,24.9-3.6c25.4-10.1,42.9-33.2,42.9-59.8c0-27.6-18.8-50-36.6-65l-12.4,9.2c16.9,13.5,32.8,31.5,32.8,54.7 c0,18.5-12.7,35.5-32.3,43.4c-14.5,5.8-33.7,5.8-49.9-7.8c-34.7-32.7-95.8-90.8-102.2-97.2c-34,28.3-77,34.2-121.1,12.6 c-28.3,39.1-81.1,60.3-108.9,61.9c-30.9,1.8-55.3-13.8-64-40.2c-2.7-0.1-6,0.3-9.4,1.5c-8.5-6.2-20.9-6.7-30,1 c18.8,6.7,30.2,22.4,37.6,37.1c-0.5,0.8-0.7,1.4-1.2,2.1c-12.1-9.5-25-15.8-38.4-19.1c-3,2-5.2,3.5-6.8,6.1 c-9.9,0.3-19.4,6.6-22.6,17.3c31.3-4.7,56,7.9,64.4,13.4c0.4,1.2,0.4,2.5,0.3,3.2c-7-1-22.1-0.4-35.7,4c-0.9,2.7-1.3,5.8-1.1,9.1 c-8.5,7.7-11.1,21-3.9,31.6c23-36.7,73.7-35.1,68.4-9.7c-2.3,5.9-7.6,9.8-14.4,12.8c12.6,9,36.9-2.2,52.7-27.9 c11.8-19.3,60.5-26.3,76.7-3.2c4.9-0.6,9.6-2,13.9-4c-1.3-4.9-8.6-16.7-14.7-22c11.2,1,21.7,9.5,26.5,15.5c3.7-1.8,6-3.3,9.2-5.9 c-1.2-5-7.7-14-12.5-19.1c6.4,0.2,18,6.4,22,10.5c2.2-2.3,6.4-6.7,8.2-9c46.8,42.8,108.1,26.4,159.2,45.3 c-5.5,32.6,2.7,89.7,29.3,112.7c46.5-23.2,77.3,29.7,66,72.2c-4,15.1-22,20-49.7,10.7c-3.6,2.7-5.8,7.4-6.3,12.5 c-8.5,5-13.9,15.2-11.4,26.1c13.3-11,30.9-14.6,49.2-12.6c0,1,0,2.5,0,2.5s-30.1,6.7-38.3,18.4c0,2.5,1.1,5.6,3,8.7 c-2.5,9.8,1.1,21,10.9,26.9c2.8-33.4,31.6-40.3,31.6-40.3s0.9,1.2,1.7,2.1c-7.2,4.9-13.3,16.9-13.6,26.9c1.2,1.3,3.2,2.5,5.4,3.6 c0.4,10.7,7.9,20.7,19.7,22.9c-9.2-26.1,0.5-43.2,8-50.2c7.5-7,16.7-10,24-2c4.6,5.8,4.6,13.3,2.4,21.3 c11.5-5.8,16.6-20.3,11.8-29.5c-10.5-20.3-13.3-42.4-12-62.4c-3.3-1.2-10.8-2.7-15.4-2.8c2-4.3,11.7-7.2,16.4-7.5 c0.6-4.4,1.5-9.8,2.5-13.9c-3.7-2.4-12.2-5.3-17.9-6.4c3.3-4.6,14.8-4.3,20.7-3.9c1.4-4.7,3.1-9.8,4.8-13.7c-2.1-2.7-9.6-7-15-8.6 c4.3-3.7,14.7-3.1,20.3-1.3c1.9-3.1,3.8-5.5,5.5-7.2C816.3,790.6,771.5,763.7,751,758.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M534.4,413.8c0.7-2,3-3,5-2.3l16.4,6.1c1.1,0.4,1.8,1.5,1.7,2.7l-0.2,3.4l-14,4.9c-2.4,0.5-4.8-1-5.3-3.4 l-0.6-3.2c-0.4-2.1-1.5-4-3.1-5.3l-0.7-0.6L534.4,413.8z M520.1,411.4c-2.4,4.5-11.2,19.9-15.2,27.3c-0.9,1.7-0.5,3.7,0.9,5 l5.6,5.2c0.8,0.8,2,1,3,0.5c3.2-1.4,9.9-4.4,11.5-5c0.9,0.8,2.6,4.4,2.8,6.2c-2.6,1.4-10.8,5.4-13.2,7.6 c-1.1,4.9-0.7,7.8,1.7,11.6c8.9,0,11.6,3.6,11.6,12.1h6.7c2.3-11.6,7.2-20.2,19.6-20.2c11.7,0,23.9,12,23.9,35.1 c0,26.2-7.2,38.8-24.1,38.8c-13.2,0-17.8-10.9-19.8-23.6c-1.5,0-4.5-0.1-5-0.1c-18.1,9.7-28.5,43.6-43.1,47.6 c1.3,2.3,2.8,4.5,4.5,6.5c1.7,2.1,4.6,2.9,7.2,2c6.2-2.4,14-6.8,18.4-11.4c-0.5,8.2-4.9,15.2-11,22.1c2.8,1.7,5.6,3.3,8.6,4.6 c2.5,1.1,5.5,0.5,7.4-1.4c4.3-4.6,9.3-11.8,12.6-17.7c1,8.6,0.3,16.7-3.2,24.7c2.6,0.6,5.2,1.1,7.8,1.5c4.2,0.6,8.6-1.4,10.5-5.2 c3-5.7,4.5-13.1,5.8-18.9c3.1,8,5.1,15.2,5.5,24.5c2.9-0.3,5.7-0.6,8.5-1.1c4.3-0.7,7.6-4.3,7.9-8.7c0.5-6.9,0.6-15.2,0-21.1 c5.7,8.7,9.9,19.4,12.1,24c3.2-1.3,6.8-3.3,10.2-5.3c3.9-2.3,5.4-7.1,3.7-11.3c-2.6-6-4.8-11.9-6.6-18.7 c4.6,5.7,10.8,10.2,16.5,13.3c3.1,1.7,6.9,0.8,9.1-1.9c2.1-2.4,4-4.9,5.7-7.5c-6-5.6-15.4-16.5-17.6-24.4 c3.7,3.7,11.5,8.6,18.2,11.4c3.2,1.4,6.9-0.2,8.2-3.5c1.2-3.1,2.3-6.3,3.2-9.5c-6.3-4-18.1-11.9-21.4-18.5 c3.2,2.2,9.8,4.6,15.9,6.1c4.1,1,8.1-2,8.2-6.2c0.1-2.5,0-4.9-0.2-7.4c-8.4-1.6-18-6.8-22.1-12.9c4.8,2.3,16.1,3.3,20.4,1.4 c-0.7-2.9-1.5-5.6-2.6-8.4c-7.6-1.8-13-6.7-16.6-12.9c5.8,2.2,10.5,2.4,12.6,1.6l-5.3-11.8c-7.5-6-12.2-19.9-7.7-29 c0,0-8.3-4.3-13.6-7.2c-2.2-1.2-3.1-3.8-2.1-6.1c3.5-8,4.6-16.4-14.9-7.9c-2.8,1.2-7.2,1.5-10.2-0.1 c-21.7-11.1-44.3-22.6-47.4-24.3c-6.4,4.9-11.4,10.6-14.7,18.5C519.4,404.7,522.1,407.6,520.1,411.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M404.8,1012.8L415,995l0.7-1.1l2.6-4.6l15.9-27.8l17.3-30.2l-0.1,0c1.6-2.8,2.3-6.2,0.3-10.6 c-1.6-3.6-4.8-6.7-8.7-7.5c-6.9-1.4-13.6,3.2-14.8,10.1c-1.1,6.1,2.6,12,8.4,13.9l-10.3,18c-1.5,2.5-4.6,3.5-7.3,2.1 c-11.1-5.9-52-25.3-74.4-31.8c-3.1,2.8-6.1,11.5-6,16.1c27,11.6,56.8,30,68.2,39c2,1.6,2.5,4.4,1.2,6.5l-17.9,31.3l0,0 c-1.3,2.2-2,4.8-1.6,7.8c1,6.6,6.6,11.6,13.7,10.9c4.4-0.4,8.4-3.4,10-7.5C415.2,1022.4,411.3,1015,404.8,1012.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    fill: "#FFFFFF",
    d: "M704.2,972.7c-28.6,20.7-77.5,35-111.1,35c-69,0-127.4-26.1-150-37.7c0,0-2.4,8.9,3.6,18.7 c-11.3-0.5-18.6,7.7-18.6,7.7c47.2,32.5,102.8,54.2,168.9,54.2c66.4,0,115.3-20.5,150.6-49.1C725,997.9,711.1,987.5,704.2,972.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderToolbarLogo);
export default __webpack_public_path__ + "static/media/HeaderToolbarLogo.ffda00cefb47a46df5023b929fe66a80.svg";
export { ForwardRef as ReactComponent };